import { isFunction, toLocalDate, setContent, toISOString, btnTextDay, themeView, btnTextWeek, viewResources } from '@kokoro-calendar/core';
import TimeGrid, { Section, Body, Day, Week } from '@kokoro-calendar/time-grid';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getContext, createEventDispatcher, onMount, afterUpdate } from 'svelte';

var root$1 = $.template(`<span></span>`);

function Label($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $resourceLabelContent = () => $.store_get(resourceLabelContent, '$resourceLabelContent', $$stores);
	const $resourceLabelDidMount = () => $.store_get(resourceLabelDidMount, '$resourceLabelDidMount', $$stores);
	const $_intlDayHeaderAL = () => $.store_get(_intlDayHeaderAL, '$_intlDayHeaderAL', $$stores);
	let resource = $.prop($$props, 'resource', 8);
	let date = $.prop($$props, 'date', 8, undefined);

	let {
		resourceLabelContent,
		resourceLabelDidMount,
		_intlDayHeaderAL
	} = getContext('state');

	const dispatch = createEventDispatcher();
	let el = $.mutable_state();
	let content = $.mutable_state();
	let ariaLabel = $.mutable_state();

	onMount(() => {
		if (isFunction($resourceLabelDidMount())) {
			$resourceLabelDidMount()({
				resource: resource(),
				date: date() ? toLocalDate(date()) : undefined,
				el: $.get(el)
			});
		}
	});

	afterUpdate(() => {
		if (date()) {
			$.set(ariaLabel, $_intlDayHeaderAL().format(date()) + ', ' + $.get(el).innerText);
		} else {
			$.set(ariaLabel, undefined);
			dispatch('text', $.get(el).innerText);
		}
	});

	$.legacy_pre_effect(
		() => (
			$resourceLabelContent(),
			$.deep_read_state(resource()),
			$.deep_read_state(date()),
			toLocalDate
		),
		() => {
			if ($resourceLabelContent()) {
				$.set(content, isFunction($resourceLabelContent())
					? $resourceLabelContent()({
						resource: resource(),
						date: date() ? toLocalDate(date()) : undefined
					})
					: $resourceLabelContent());
			} else {
				$.set(content, resource().title);
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var span = root$1();

	$.bind_this(span, ($$value) => $.set(el, $$value), () => $.get(el));
	$.action(span, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));
	$.template_effect(() => $.set_attribute(span, 'aria-label', $.get(ariaLabel)));
	$.append($$anchor, span);
	$.pop();
	$$cleanup();
}

var root_3 = $.template(`<div><time></time></div>`);
var root_4 = $.template(`<div><!></div>`);
var root_7 = $.template(`<div role="columnheader"><!></div>`);
var root_8 = $.template(`<div role="columnheader"><time></time></div>`);
var root_5 = $.template(`<div></div>`);
var root_2 = $.template(`<div><!> <!></div>`);
var root_12 = $.template(`<div></div>`);
var root_15 = $.template(`<div><!></div>`);
var root_9 = $.template(`<div><div><!> <div></div></div></div>`);
var root_17 = $.template(`<div></div>`);
var root = $.template(`<div><!> <div></div></div> <!> <!>`, 1);

function View($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $datesAboveResources = () => $.store_get(datesAboveResources, '$datesAboveResources', $$stores);
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $_viewResources = () => $.store_get(_viewResources, '$_viewResources', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_intlDayHeaderAL = () => $.store_get(_intlDayHeaderAL, '$_intlDayHeaderAL', $$stores);
	const $_intlDayHeader = () => $.store_get(_intlDayHeader, '$_intlDayHeader', $$stores);
	const $allDaySlot = () => $.store_get(allDaySlot, '$allDaySlot', $$stores);

	let {
		datesAboveResources,
		_viewDates,
		_viewResources,
		_intlDayHeader,
		_intlDayHeaderAL,
		allDaySlot,
		theme
	} = getContext('state');

	let loops = $.mutable_state();
	let resourceLabels = $.mutable_state([]);

	$.legacy_pre_effect(
		() => (
			$datesAboveResources(),
			$_viewDates(),
			$_viewResources()
		),
		() => {
			$.set(loops, $datesAboveResources() ? [$_viewDates(), $_viewResources()] : [$_viewResources(), $_viewDates()]);
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var fragment = root();
	var div = $.first_child(fragment);
	var node = $.child(div);

	Section(node, {
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			$.each(node_1, 1, () => $.get(loops)[0], $.index, ($$anchor, item0, i) => {
				var div_1 = root_2();
				var node_2 = $.child(div_1);

				{
					var consequent = ($$anchor) => {
						var div_2 = root_3();
						var time = $.child(div_2);

						$.action(time, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayHeader().format($.get(item0)));
						$.reset(div_2);

						$.template_effect(
							($0, $1, $2) => {
								$.set_class(div_2, `${$theme().day ?? ''} ${$0 ?? ''}`);
								$.set_attribute(time, 'datetime', $1);
								$.set_attribute(time, 'aria-label', $2);
							},
							[
								() => $theme().weekdays?.[$.get(item0).getUTCDay()],
								() => toISOString($.get(item0), 10),
								() => $_intlDayHeaderAL().format($.get(item0))
							],
							$.derived_safe_equal
						);

						$.append($$anchor, div_2);
					};

					var alternate = ($$anchor) => {
						var div_3 = root_4();
						var node_3 = $.child(div_3);

						Label(node_3, {
							get resource() {
								return $.get(item0);
							},
							$$events: {
								text: (e) => $.mutate(resourceLabels, $.get(resourceLabels)[i] = e.detail + ', ')
							}
						});

						$.reset(div_3);
						$.template_effect(() => $.set_class(div_3, $theme().day));
						$.append($$anchor, div_3);
					};

					$.if(node_2, ($$render) => {
						if ($datesAboveResources()) $$render(consequent); else $$render(alternate, false);
					});
				}

				var node_4 = $.sibling(node_2, 2);

				{
					var consequent_2 = ($$anchor) => {
						var div_4 = root_5();

						$.each(div_4, 5, () => $.get(loops)[1], $.index, ($$anchor, item1) => {
							var fragment_2 = $.comment();
							var node_5 = $.first_child(fragment_2);

							{
								var consequent_1 = ($$anchor) => {
									var div_5 = root_7();
									var node_6 = $.child(div_5);

									Label(node_6, {
										get resource() {
											return $.get(item1);
										},
										get date() {
											return $.get(item0);
										}
									});

									$.reset(div_5);
									$.template_effect(() => $.set_class(div_5, $theme().day));
									$.append($$anchor, div_5);
								};

								var alternate_1 = ($$anchor) => {
									var div_6 = root_8();
									var time_1 = $.child(div_6);

									$.action(time_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayHeader().format($.get(item1)));
									$.reset(div_6);

									$.template_effect(
										($0, $1, $2) => {
											$.set_class(div_6, `${$theme().day ?? ''} ${$0 ?? ''}`);
											$.set_attribute(time_1, 'datetime', $1);
											$.set_attribute(time_1, 'aria-label', `${$.get(resourceLabels)[i] ?? ''}${$2 ?? ''}`);
										},
										[
											() => $theme().weekdays?.[$.get(item1).getUTCDay()],
											() => toISOString($.get(item1), 10),
											() => $_intlDayHeaderAL().format($.get(item1))
										],
										$.derived_safe_equal
									);

									$.append($$anchor, div_6);
								};

								$.if(node_5, ($$render) => {
									if ($datesAboveResources()) $$render(consequent_1); else $$render(alternate_1, false);
								});
							}

							$.append($$anchor, fragment_2);
						});

						$.reset(div_4);
						$.template_effect(() => $.set_class(div_4, $theme().days));
						$.append($$anchor, div_4);
					};

					$.if(node_4, ($$render) => {
						if ($.get(loops)[1].length > 1) $$render(consequent_2);
					});
				}

				$.reset(div_1);
				$.template_effect(() => $.set_class(div_1, $theme().resource));
				$.append($$anchor, div_1);
			});

			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	var div_7 = $.sibling(node, 2);

	$.reset(div);

	var node_7 = $.sibling(div, 2);

	{
		var consequent_4 = ($$anchor) => {
			var div_8 = root_9();
			var div_9 = $.child(div_8);
			var node_8 = $.child(div_9);

			Section(node_8, {
				children: ($$anchor, $$slotProps) => {
					var fragment_3 = $.comment();
					var node_9 = $.first_child(fragment_3);

					{
						var consequent_3 = ($$anchor) => {
							var fragment_4 = $.comment();
							var node_10 = $.first_child(fragment_4);

							$.each(node_10, 1, $_viewDates, $.index, ($$anchor, date) => {
								var div_10 = root_12();

								$.each(div_10, 5, $_viewResources, $.index, ($$anchor, resource) => {
									const expression = $.derived_safe_equal(() => [$.get(date)]);

									Week($$anchor, {
										get dates() {
											return $.get(expression);
										},
										get resource() {
											return $.get(resource);
										}
									});
								});

								$.reset(div_10);
								$.template_effect(() => $.set_class(div_10, $theme().resource));
								$.append($$anchor, div_10);
							});

							$.append($$anchor, fragment_4);
						};

						var alternate_2 = ($$anchor) => {
							var fragment_6 = $.comment();
							var node_11 = $.first_child(fragment_6);

							$.each(node_11, 1, $_viewResources, $.index, ($$anchor, resource) => {
								var div_11 = root_15();
								var node_12 = $.child(div_11);

								Week(node_12, {
									get dates() {
										return $_viewDates();
									},
									get resource() {
										return $.get(resource);
									}
								});

								$.reset(div_11);
								$.template_effect(() => $.set_class(div_11, $theme().resource));
								$.append($$anchor, div_11);
							});

							$.append($$anchor, fragment_6);
						};

						$.if(node_9, ($$render) => {
							if ($datesAboveResources()) $$render(consequent_3); else $$render(alternate_2, false);
						});
					}

					$.append($$anchor, fragment_3);
				},
				$$slots: { default: true }
			});

			var div_12 = $.sibling(node_8, 2);

			$.reset(div_9);
			$.reset(div_8);

			$.template_effect(() => {
				$.set_class(div_8, $theme().allDay);
				$.set_class(div_9, $theme().content);
				$.set_class(div_12, $theme().hiddenScroll);
			});

			$.append($$anchor, div_8);
		};

		$.if(node_7, ($$render) => {
			if ($allDaySlot()) $$render(consequent_4);
		});
	}

	var node_13 = $.sibling(node_7, 2);

	Body(node_13, {
		children: ($$anchor, $$slotProps) => {
			var fragment_7 = $.comment();
			var node_14 = $.first_child(fragment_7);

			$.each(node_14, 1, () => $.get(loops)[0], $.index, ($$anchor, item0) => {
				var div_13 = root_17();

				$.each(div_13, 5, () => $.get(loops)[1], $.index, ($$anchor, item1) => {
					const expression_1 = $.derived_safe_equal(() => $datesAboveResources() ? $.get(item0) : $.get(item1));
					const expression_2 = $.derived_safe_equal(() => $datesAboveResources() ? $.get(item1) : $.get(item0));

					Day($$anchor, {
						get date() {
							return $.get(expression_1);
						},
						get resource() {
							return $.get(expression_2);
						}
					});
				});

				$.reset(div_13);
				$.template_effect(() => $.set_class(div_13, $theme().resource));
				$.append($$anchor, div_13);
			});

			$.append($$anchor, fragment_7);
		},
		$$slots: { default: true }
	});

	$.template_effect(() => {
		$.set_class(div, $theme().header);
		$.set_class(div_7, $theme().hiddenScroll);
	});

	$.append($$anchor, fragment);
	$.pop();
	$$cleanup();
}

var index = {
    createOptions(options) {
        options.datesAboveResources = false;
        // Common options
        options.buttonText.resourceTimeGridDay = 'resources';
        options.buttonText.resourceTimeGridWeek = 'resources';
        options.view = 'resourceTimeGridWeek';
        options.views.resourceTimeGridDay = {
            buttonText: btnTextDay,
            component: View,
            duration: { days: 1 },
            theme: themeView('ec-time-grid ec-resource-day-view')
        };
        options.views.resourceTimeGridWeek = {
            buttonText: btnTextWeek,
            component: View,
            duration: { weeks: 1 },
            theme: themeView('ec-time-grid ec-resource-week-view')
        };
    },

    createStores(state) {
        if (!('_times' in state)) {
            TimeGrid.createStores(state);
        }
        if (!('_viewResources' in state)) {
            state._viewResources = viewResources(state);
        }
    }
};

export { index as default };
